import { render, staticRenderFns } from "./ProofreadIcon.vue?vue&type=template&id=96292122&"
import script from "./ProofreadIcon.vue?vue&type=script&lang=js&"
export * from "./ProofreadIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports